/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { tasksV1ExportDoneRetrieve } from '../fetch-client';
import { useFetchOpts } from '../use-fetch-opts';

export namespace DownloadTasks {
  export type Input = { fileName: string };
  export type Output = { file: File };

  function outputFromResult(result: Blob, input: Input): Output {
    return { file: new File([result], input.fileName) };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const result = await ok(tasksV1ExportDoneRetrieve({}, opts));
        const output = outputFromResult(result, input);
        return output;
      },
    });
  }
}
